import { RootState } from '../rootReducer';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

export const hasPastProTrial = (state: RootState): boolean =>
  !!state.packagesInfo.past.trial.find(trial => trial.descriptor === 'proTrial');

export const hasCurrentProTrial = (state: RootState): boolean =>
  !!state.packagesInfo.current.trial.find(trial => trial.descriptor === 'proTrial');

export const selectPackagesInfoLoading = (state: RootState): boolean =>
  state.packagesInfo.loading;

export const hasPastEnterpriseTrial = (state: RootState): boolean => {
  if (!isFeatureEnabled(Features.TrialsOfTiers)) {
    return false;
  }
  return !!state.packagesInfo?.past?.trial?.some((trial) => trial.descriptor === 'enterpriseTrial');
};

export const hasCurrentEnterpriseTrial = (state: RootState): boolean => {
  if (!isFeatureEnabled(Features.TrialsOfTiers)) {
    return false;
  }
  return !!state.packagesInfo?.current?.trial?.some((trial) => trial.descriptor === 'enterpriseTrial');
};
